import React, {PropTypes} from 'react';
import {favCheck} from '../../../helpers/favCheck.js';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

class favBtn extends React.Component {

  static propTypes = {
    itemType: PropTypes.string,
    onClick: PropTypes.func,
    pk: PropTypes.number,
    restaurant: PropTypes.string,
    favList: PropTypes.bool
  };


  constructor(props) {
    super(props);
    this.favsTotal = 0;
    this.state = {
      favToggle: false
    };

    this.saveCookie = this.saveCookie.bind(this);
  }

  componentDidMount() {
    this.setState({favToggle: favCheck(this.props.pk, this.props.itemType)});

    if (cookies.get('shortlist') === undefined) {
      const cookieString = 'food=&drink=';
      cookies.set('shortlist', cookieString, {path: this.props.restaurant + '/', maxAge: 1300});
    }
    if (this.props.favList === true) {
      this.setState({favToggle: true});
    }
  }

  componentDidUpdate(prevProps) {
    //VERIFIES IF THE USER CAME FROM THE LIST OR ANOTHER ITEM, EITHER WAY THE PK SHOULD BE DIFFERENT
    if (prevProps.pk !== this.props.pk) {
      if (cookies.get('shortlist') === undefined) {
        const cookieString = 'food=&drink=';
        cookies.set('shortlist', cookieString, {path: this.props.restaurant + '/', maxAge: 1300});
      }
    }
  }

  saveCookie() {
    const itemId = String(this.props.pk);
    const itemType = this.props.itemType;

    //Get the cookie and store it into an array
    //ex: food=1,2,3&drink=4,5,6 becomes favList=["food=1,2,3", "drink=4,5,6"]
    const favList = cookies.get('shortlist').split('&');
    let drinkArray = [];
    let foodArray = [];
    let index = null;

    //Build the food and drink arrays from the cookie info
    //Firstly, get a substring from the cookie with the values from drinks and food
    //ex: favList=["food=1,2,3", "drink=4,5,6"] become "1,2,3" and "4,5,6"
    const foodString = favList[0].substring(favList[0].indexOf('=') + 1);
    const drinkString = favList[1].substring(favList[1].indexOf('=') + 1);

    //TOGGLE, if the status is true sets to false, vice-versa
    this.setState({favToggle: !this.state.favToggle});
    //Then split the substring into an array we can work with
    //ex: "1,2,3" becomes foodArray=[1,2,3]


    if (foodString.length > 0) {
      foodArray = foodString.split(',');
    }
    if (drinkString.length > 0) {
      drinkArray = drinkString.split(',');
    }

    //Check if the selected item is already in array
    //If true, it is removed, if false it is added
    //Checking for food
    if (itemType === 'food') {
      index = foodArray.indexOf(itemId);

      if (index === -1) {
        foodArray.push(itemId);
      }
      else {
        foodArray.splice(index, 1);
      }
    }
    //And for drinks
    else {
      index = drinkArray.indexOf(itemId);
      if (index === -1) {
        drinkArray.push(itemId);
      }
      else {
        drinkArray.splice(index, 1);
      }
    }

    this.favsTotal = foodArray.length + drinkArray.length;
    cookies.set('favsTotal', this.favsTotal, {path: this.props.restaurant + '/', maxAge: 1300});

    //Finally, convert and then add both arrays into a final string that we can save into the cookie.
    const cookieString = 'food=' + foodArray.toString() + '&drink=' + drinkArray.toString();

    cookies.set('shortlist', cookieString, {path: this.props.restaurant + '/', maxAge: 1300});
    if (typeof this.props.onClick === 'function') {
      this.props.onClick(this.favsTotal);
    }

  }

render() {
    //this.setState({favToggle: favCheck(this.props.pk, this.props.itemType)});

    return (
      <button className={'fav-btn btn ' + favCheck(this.props.pk, this.props.itemType)} onClick={this.saveCookie}/>
    );
  }
}

export default favBtn;






/** WEBPACK FOOTER **
 ** ./src/components/restaurant/core/FavBtn.js
 **/